module.exports = __webpack_public_path__ + "static/media/login-background.0a02f066.png";